import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import Router from 'routes';
import reportWebVitals from './reportWebVitals';
import SvaraAppProvider from 'provider/SvaraAppProvider';
import AssetsProvider from 'provider/AssetsProvider';

ReactDOM.render(
    <SvaraAppProvider>
        <AssetsProvider>
            <BrowserRouter>
                <Router />
            </BrowserRouter>
        </AssetsProvider>
    </SvaraAppProvider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
